<div class="deals-offers-widget" [class.deals-offers-widget--small]="size === 'small'"
    [class.deals-offers-widget--medium]="size === 'medium'" [class.deals-offers-widget--half]="size === 'half'"
    [class.deals-offers-widget--full]="size === 'full'">

    <!-- Header -->
    <div class="deals-offers-widget__header">
        <div class="deals-offers-widget__header-content">
            <div class="deals-offers-widget__title">{{ title }}</div>

            <!-- Offer Slider Navigation Arrows -->
            <div *ngIf="!isEditMode && size === 'small'" class="deals-offers-widget__nav-controls">
                <button class="deals-offers-widget__nav-arrow" [disabled]="!canGoPreviousOffer()"
                    (click)="previousOffer()">
                    <img src="assets/icons/arrow-left.svg" alt="Previous Offer">
                </button>
                <button class="deals-offers-widget__nav-arrow" [disabled]="!canGoNextOffer()" (click)="nextOffer()">
                    <img src="assets/icons/arrow-right.svg" alt="Next Offer">
                </button>
            </div>
            <div *ngIf="size !== 'small'" class="deals-offers-widget__nav-controls">
                <button class="deals-offers-widget__nav-arrow" [disabled]="!canGoPreviousOffer()"
                    (click)="previousOffer()">
                    <img src="assets/icons/img-image-1.svg" alt="Previous Offer">
                </button>
                <button class="deals-offers-widget__nav-arrow" [disabled]="!canGoNextOffer()" (click)="nextOffer()">
                    <img src="assets/icons/img-arrow-right-2.svg" alt="Next Offer">
                </button>
            </div>

            <!-- Edit Icon -->
            <ng-container *ngIf="isEditMode">
                <div (click)="toggleSizeDropdown(index, $event)" class="ai-advice-widget__icon-container"
                    cdkOverlayOrigin #editTrigger="cdkOverlayOrigin">
                    <div class="ai-advice-widget__icon">
                        <img src="assets/icons/widget/pencil.svg" alt="Edit">
                    </div>
                </div>
                <!-- Size Dropdown -->
                <app-widget-edit [editTrigger]="editTrigger" [index]="index" [activeDropdownIndex]="activeDropdownIndex"
                    [getAvailableSizes]="getAvailableSizes" [changeWidgetSize]="changeWidgetSize"
                    [removeWidget]="removeWidget" [toggleSizeDropdown]="toggleSizeDropdown">
                </app-widget-edit>
            </ng-container>
            <ng-container *ngIf="isAddMode">
                <img class="add-widget-btn-icon no-dark-filter" src="assets/icons/img_frame-1171275385.png"
                    alt="Settings" (click)="addWidget.emit(); $event.stopPropagation()" />
            </ng-container>
        </div>
    </div>

    <!-- Content Section -->
    <div class="deals-offers-widget__content">
        <!-- Categories Tabs -->
        <div *ngIf="size !== 'small'" class="deals-offers-widget__categories-wrapper">
            <div class="deals-offers-widget__categories">
                <button *ngFor="let category of categories" class="deals-offers-widget__category-btn"
                    [class.deals-offers-widget__category-btn--active]="selectedCategory === category"
                    (click)="selectCategory(category, $event)">
                    {{ category }}
                </button>
            </div>
        </div>

        <!-- Offers List -->
        <div class="deals-offers-widget__offers" #offersContainer>
            <div class="deals-offers-widget__offers-track" [style.transform]="getSliderTransform()">
                <div *ngFor="let offer of filteredOffers" class="deals-offers-widget__offer-card"
                    (click)="openVoucherModal(offer)">
                    <!-- Offer Image -->
                    <div class="deals-offers-widget__offer-image">
                        <img class="no-dark-filter" [src]="offer.image" [alt]="offer.title">
                    </div>

                    <!-- Offer Details -->
                    <div class="deals-offers-widget__offer-details">
                        <!-- Category Badge -->
                        <div class="deals-offers-widget__offer-badge" [style.color]="offer.categoryColor"
                            [style.background-color]="offer.categoryBgColor">
                            {{ offer.category }}
                        </div>

                        <!-- Title -->
                        <div class="deals-offers-widget__offer-title">
                            {{ offer.title }}
                        </div>

                        <!-- Countdown Timer -->
                        <div class="deals-offers-widget__offer-countdown">
                            <!-- <img src="assets/icons/img-stopwatch.svg" alt="Timer"
                                class="deals-offers-widget__timer-icon">
                            <span>{{ offer.countdown }}</span> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- See All Button -->
        <div class="deals-offers-widget__footer">
            <button class="deals-offers-widget__see-all-btn">
                <span>See All</span>
                <img src="assets/icons/arrow-right.svg" alt="See All">
            </button>
        </div>
    </div>

    <app-voucher-purchase-modal *ngIf="showVoucherModal && selectedVoucherBrand" [brand]="selectedVoucherBrand"
        [mobileNumber]="userMobile" (close)="closeVoucherModal()">
    </app-voucher-purchase-modal>
</div>